var _style, _defs, _path, _path2, _g, _g2, _g3, _defs2, _path3, _path4, _path5, _defs3, _path6, _path7, _g4, _g5, _g6, _defs4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st1 {\n\t\t\tclip-path: url(#SVGID_00000037655676093370881030000010382206697487905982_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st2 {\n\t\t\tfill: #495355;\n\t\t}\n\n\t\t.st3 {\n\t\t\tfill: #4C5658;\n\t\t}\n\n\t\t.st4 {\n\t\t\tfill: #465052;\n\t\t}\n\n\t\t.st5 {\n\t\t\tfill: #637073;\n\t\t}\n\n\t\t.st6 {\n\t\t\tclip-path: url(#SVGID_00000072253688866821076470000002723360460986040229_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st7 {\n\t\t\tfill: #5C696C;\n\t\t}\n\n\t\t.st8 {\n\t\t\tfill: #5A6668;\n\t\t}\n\n\t\t.st9 {\n\t\t\tfill: #576365;\n\t\t}\n\n\t\t.st10 {\n\t\t\tclip-path: url(#SVGID_00000109030018804631450870000015445208242338154394_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st11 {\n\t\t\tfill: #485153;\n\t\t}\n\n\t\t.st12 {\n\t\t\tclip-path: url(#SVGID_00000091712330789469872580000009286477452258642608_);\n\t\t\tenable-background: new;\n\t\t}\n\n\t\t.st13 {\n\t\t\tfill: #4E595B;\n\t\t}\n\n\t\t.st14 {\n\t\t\tfill: #515C5F;\n\t\t}\n\n\t\t.st15 {\n\t\t\tfill: #545F62;\n\t\t}\n\n\t\t.st16 {\n\t\t\tfill: #7A8B8E;\n\t\t}\n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_metro-truck"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M704.34,719.87l-91.17-49.6c-24.78-13.48-32.9-47.56-18.02-77.33l91.17,49.6 C671.45,672.31,679.57,706.39,704.34,719.87z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043431573523054847900000007368653715365702824_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043431573523054847900000007368653715365702824_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M704.34,719.87l-91.17-49.6c-22.72-12.36-31.43-42.03-21.26-69.83l91.17,49.6 C672.91,677.83,681.63,707.51,704.34,719.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M683.09,650.04l-91.17-49.6c0.92-2.52,2-5.03,3.24-7.51l91.17,49.6 C685.09,645.01,684.01,647.52,683.09,650.04"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "777.38,540.66 686.21,491.06 645.09,407.75 736.27,457.34  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "679.06,554.48 587.89,504.88 686.21,491.06 777.38,540.66  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "679.31,435.65 588.14,386.05 670.67,374.45 761.84,424.05  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000130615144024236471910000018351248684951988664_",
    className: "st0",
    d: "M575.44,303.36l91.17,49.6 c-4.24-2.31-9.27-3.29-14.66-2.55l-91.17-49.6C566.17,300.07,571.2,301.05,575.44,303.36z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054979900419928016370000001690842523213062039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130615144024236471910000018351248684951988664_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054979900419928016370000001690842523213062039_)",
      enableBackground: "new"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M651.95,350.41l-91.17-49.6c3.32-0.46,6.51-0.26,9.46,0.5l91.17,49.6 C658.46,350.15,655.28,349.95,651.95,350.41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M661.41,350.91l-91.17-49.6c1.52,0.39,2.98,0.93,4.36,1.61l91.17,49.6 C664.39,351.84,662.93,351.3,661.41,350.91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M665.77,352.52l-91.17-49.6c0.28,0.14,0.56,0.28,0.84,0.44l91.17,49.6 C666.34,352.8,666.06,352.66,665.77,352.52"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106838595352197672160000005410476382570416038_",
    className: "st0",
    d: "M456.65,754.68l-91.17-49.6 c-24.78-13.48-32.9-47.55-18.03-77.33l91.17,49.6C423.75,707.13,431.87,741.2,456.65,754.68z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039105529477149496110000013327851584366611090_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106838595352197672160000005410476382570416038_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039105529477149496110000013327851584366611090_)",
      enableBackground: "new"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M456.65,754.68l-91.17-49.6c-22.72-12.36-31.44-42.04-21.26-69.84l91.17,49.6 C425.21,712.64,433.93,742.32,456.65,754.68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M435.39,684.84l-91.17-49.6c0.92-2.52,2-5.02,3.23-7.49l91.17,49.6 C437.39,679.82,436.31,682.32,435.39,684.84"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "403.72,682.25 312.55,632.66 285.09,606.82 376.26,656.41  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "404.27,385.21 313.1,335.62 560.78,300.81 651.95,350.41  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "376.26,656.41 285.09,606.82 285.53,369.19 376.7,418.79  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128463998046260608640000018394505762543977903_",
    className: "st0",
    d: "M376.7,418.79l-91.17-49.6 c0.07-16.39,12.39-31.39,27.57-33.57l91.17,49.6C389.09,387.4,376.77,402.4,376.7,418.79z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083069629635376566250000012431402076604864665_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128463998046260608640000018394505762543977903_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083069629635376566250000012431402076604864665_)",
      enableBackground: "new"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.7,418.79l-91.17-49.6c0.02-4.02,0.77-7.96,2.12-11.64l91.17,49.6 C377.47,410.83,376.72,414.77,376.7,418.79"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378.83,407.15l-91.17-49.6c0.59-1.6,1.29-3.15,2.09-4.65l91.17,49.6 C380.11,403.99,379.41,405.54,378.83,407.15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M380.92,402.5l-91.17-49.6c0.68-1.26,1.43-2.48,2.25-3.65l91.17,49.6 C382.35,400.02,381.6,401.24,380.92,402.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M383.17,398.85l-91.17-49.6c0.77-1.1,1.6-2.15,2.48-3.15l91.17,49.6 C384.77,396.7,383.94,397.75,383.17,398.85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M385.65,395.7l-91.17-49.6c0.89-1,1.83-1.96,2.82-2.84l91.17,49.6 C387.48,393.75,386.54,394.7,385.65,395.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M388.47,392.86l-91.17-49.6c1.06-0.95,2.18-1.84,3.34-2.64l91.17,49.6 C390.64,391.02,389.53,391.9,388.47,392.86"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M391.8,390.21l-91.17-49.6c1.43-0.99,2.93-1.85,4.48-2.59l91.17,49.6 C394.73,388.36,393.23,389.23,391.8,390.21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M396.29,387.63l-91.17-49.6c2.53-1.19,5.21-2.01,7.98-2.41l91.17,49.6 C401.5,385.61,398.82,386.44,396.29,387.63"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M816.67,535.14l-0.17,89.1l-34.86,4.9c9.81,17.01,9.77,39.68-0.11,59.46 c-10.23,20.48-28.75,33.72-47.76,36.39c-9.35,1.31-18.82,0.07-27.48-4.12c-26.29-12.72-35.23-47.79-19.96-78.33l-152.38,21.42 c9.81,17,9.77,39.66-0.11,59.43c-10.23,20.49-28.75,33.74-47.77,36.41c-9.34,1.31-18.81,0.07-27.46-4.11 c-26.29-12.72-35.24-47.78-19.98-78.33l-34.9,4.91l-27.46-25.84l0.44-237.62c0.07-16.39,12.39-31.39,27.57-33.57l247.68-34.81 c15.18-2.08,27.45,9.46,27.47,25.84l-0.11,59.41l82.53-11.6L816.67,535.14z M679.06,554.48l98.32-13.82l-41.11-83.31 l-57.04,8.02L679.06,554.48"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.93bbc0051ac53113d66f44611598b002.svg";
export { ForwardRef as ReactComponent };